import store from "../../store";
import { IDocumentDataDragParameter } from ".";

export class DocumentDataDropManager {
  static get parameter(): IDocumentDataDragParameter {
    return store.state.documentDataDragParameter;
  }

  static set parameter(payload: IDocumentDataDragParameter) {
    store.commit("setDocumentDataDragParameter", payload);
  }
}
